import { render, staticRenderFns } from "./SuccessDialog.vue?vue&type=template&id=b5c0e9e0&scoped=true"
import script from "./SuccessDialog.vue?vue&type=script&lang=js"
export * from "./SuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./SuccessDialog.vue?vue&type=style&index=0&id=b5c0e9e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c0e9e0",
  null
  
)

export default component.exports